import { Dialog } from '@ordr-as/umami-react/dialog';
import { Radio, RadioGroup } from '@ordr-as/umami-react/radio';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { DiscountDto } from '../../../generated-api';
import { useLocation } from '../../context/LocationContext';
import { useDiscounts } from '../../context/DiscountStore';
import { getLocationAdminUrl } from '../../utils/url-builder';

type DiscountDialogProps = {
  appliedDiscount: DiscountDto | undefined;
  onApplyDiscount: (discount: DiscountDto | undefined) => void;
  onClose: () => void;
};

const DiscountDialog = (props: DiscountDialogProps) => {
  const { appliedDiscount, onApplyDiscount, onClose } = props;
  const intl = useIntl();
  const [selectedDiscount, setSelectedDiscount] = useState<DiscountDto | undefined>(appliedDiscount);
  const { location } = useLocation();
  const discounts = useDiscounts();
  const discountUrl = `${getLocationAdminUrl(location.id)}/discounts`;

  const handleSaveDiscount = () => {
    onApplyDiscount(selectedDiscount);
    onClose();
  };

  const availableDiscounts = discounts
    .filter((discount) => discount.discountCodes.length > 0)
    .sort((a, b) => a.amount - b.amount);

  const handleSelectDiscount = (index: string) => {
    if (index === '') {
      return setSelectedDiscount(undefined);
    }

    setSelectedDiscount(availableDiscounts[parseInt(index)]);
  };

  return (
    <Dialog
      onClose={onClose}
      className="w-full mx-4 tablet:w-1/2 tablet:mx-0"
      title={intl.formatMessage({ id: `cart.discount.dialog.title` })}
      actionLabel={intl.formatMessage({ id: 'generic.confirm' })}
      onAction={handleSaveDiscount}
      secondaryActionLabel={intl.formatMessage({ id: 'generic.cancel' })}
      onSecondaryAction={onClose}
      isDisabledAction={!appliedDiscount && !selectedDiscount}
    >
      <RadioGroup
        aria-label="Select Option"
        onChange={handleSelectDiscount}
        defaultValue={availableDiscounts.findIndex((discount) => discount === appliedDiscount).toString()}
        className="py-2"
      >
        <>
          {appliedDiscount && (
            <Radio className="pb-2 mb-4" value={''}>
              <span className="flex justify-between w-full">
                <span>{intl.formatMessage({ id: 'cart.discount.discounts.no' })}</span>
              </span>
            </Radio>
          )}
          {availableDiscounts.map((discount, index) => {
            return (
              <Radio key={`${discount.id}`} className="pb-2 mb-4" value={index.toString()}>
                <span className="flex justify-between w-full">
                  <span className="capitalize">{discount.name}</span>
                  <span className="text-grey-dark">-{discount.amount}%</span>
                </span>
              </Radio>
            );
          })}
        </>
      </RadioGroup>
      <div className="p-2 bg-purple-lightest text-grey-dark">
        <b>{intl.formatMessage({ id: 'cart.discount.info.title' })}</b>{' '}
        {intl.formatMessage({ id: 'cart.discount.info.body' })}{' '}
        <a className="underline" href={discountUrl}>
          {intl.formatMessage({ id: 'cart.discount.info.linkText' })}
        </a>
      </div>
    </Dialog>
  );
};

export default DiscountDialog;
